import { FormControl } from '@angular/forms';
import { Tag } from '@api/index';

export interface MediaFiles extends SelectedFile {
  id: string;
  name: string;
  customerId: number;
  clientId: number;
  tags: Tag[];
}

export interface MediaItem {
  client: number;
  id: string;
  name: string;
  selectedFile: SelectedFile;
  status: UploadStatus;
  tags: Tag[];
  uploadProgress: number;
}

export interface MediaUploadItem {
  clientId: string;
  customerId: number;
  errorMessage: undefined
  filePreview: string;
  fileSize: number;
  format: MediaFormat;
  id: string;
  index: string;
  isClientBoxChecked: boolean;
  name: string;
  selectedFile: SelectedFile;
  status: UploadStatus;
  tags: Tag[];
  uploadProgress: number;
}

export interface MediaFormGroup {
  customerId: FormControl<number>;
  medias: MediaFiles[];
}

export interface MediaFile {
  filePreview: string;
  fileSize: number;
  format: MediaFormat;
  index: null;
  name: string;
  selectedFile: SelectedFile;
}

export enum MediaFormat {
  Video = 'video',
  Image = 'image',
  JSON = 'json',
}

export interface SelectedFile {
  index: string;
  selectedFile: File;
  fileSize: number;
  filePreview?: string;
  format?: MediaFormat;
  videoDuration?: number;
  name?: string;
}

export enum UploadStatus {
  success = 'success',
  error = 'error',
}
